<template>
  <div class="body-2">
    {{ i18n(translations.productVatIncludedInfo) }}
    <RevLink target="_blank" :to="i18n(translations.productVatFaqLink)">
      {{ i18n(translations.productVatFaq) }}
    </RevLink>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import translations from './Vat.translations'

const i18n = useI18n()
</script>
